import { useState, useEffect } from 'react';

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    {
      image: 'https://public.readdy.ai/ai/img_res/7e51a236c48ca9a6ebb53f756ffdc456.jpg',
      title: '30년 전통의 목형 제작',
      subtitle: '레이저 가공 전문기업',
      company: '재기목형'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=advanced%20laser%20cutting%20machine%20in%20action%20precision%20manufacturing%20high%20tech%20industrial%20equipment%20blue%20laser%20beam%20cutting%20wood%20modern%20factory%20setting%20professional%20technology%20clean%20workspace%20industrial%20innovation%20manufacturing%20precision%20warm%20lighting&width=1920&height=1080&seq=hero-slide-2&orientation=landscape',
      title: '정밀한 레이저 가공',
      subtitle: '뉴테크',
      company: '재기목형'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <div className="relative h-screen w-full overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="absolute inset-0">
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
          </div>
          <div className="relative h-full flex items-center justify-center">
            <div className="text-center text-white px-4 max-w-5xl">
              <h1 className="text-5xl md:text-7xl font-bold mb-6 tracking-tight leading-tight">
                {slide.title}
                <br />
                <span className="text-amber-400">{slide.subtitle}</span>
              </h1>
              <p className="text-2xl md:text-3xl font-light mb-8 tracking-wide">{slide.company}</p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
                <a 
                  href="tel:02-2263-8248"
                  className="flex items-center gap-3 bg-amber-500 hover:bg-amber-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
                >
                  <i className="ri-phone-fill text-2xl"></i>
                  <span>02-2263-8248</span>
                </a>
                <a 
                  href="#quote"
                  className="flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 border-2 border-white/30 whitespace-nowrap"
                >
                  <span>견적 문의</span>
                  <i className="ri-arrow-right-line text-xl"></i>
                </a>
              </div>
              <p className="text-base md:text-lg text-white/90">방산시장에서 30여 년간 성장해온 목형 제작 전문기업</p>
            </div>
          </div>
        </div>
      ))}
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-3 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-12 h-1 rounded-full transition-all duration-300 ${
              index === currentSlide ? 'bg-amber-400' : 'bg-white/40 hover:bg-white/60'
            }`}
            aria-label={`슬라이드 ${index + 1}`}
          ></button>
        ))}
      </div>
    </div>
  );
}
